// extracted by mini-css-extract-plugin
export default {"wrapper":"AbsolutCentered_wrapper__dDfm4"};